<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bardashboard></app-side-menu-bardashboard>
<div class="main-content" [formGroup]="qamatrixAnalyticsForm">
    <div class="filters">
      <!-- Reference Year(Year1) -->
      <div class="filtersDropdown">
        <mat-form-field appearance="fill">
        <mat-label>Reference Year</mat-label>
        <mat-select formControlName="Year1Control" (selectionChange)="clearData()">
            <mat-option *ngFor="let year of yearSelect" [value]="year">{{year}}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </div>
      <!-- Target Year(Year2) -->
      <div class="filtersDropdown">
        <mat-form-field appearance="fill">
        <mat-label>Target Year</mat-label>
        <mat-select formControlName="Year2Control" (selectionChange)="clearData()">
            <mat-option *ngFor="let year of yearSelect" [value]="year">{{year}}
            </mat-option>
        </mat-select>
        </mat-form-field>
      </div>
      <!-- Cluster -->
      <div class="filtersDropdown">
        <mat-form-field appearance="fill" class="datepickerwidth">
          <mat-label>Select BU/GBU Sub-Region</mat-label>
          <mat-select #clusterControl [(ngModel)]="clusterdefault" formControlName="clusters" multiple (selectionChange)="loadSite()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
                (change)="toggleAllSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let clus of cluster" (click)="optionClick()" [disabled]="disableCluster" [value]="clus">
              {{clus}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Site -->
      <div class="filtersDropdown">
        <mat-form-field appearance="fill" class="datepickerwidth">
          <mat-label>Select Site</mat-label>
          <mat-select #siteControl [(ngModel)]="sitedefault" formControlName="sites" multiple (selectionChange)="loadBigCategory()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
                (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
              {{fact}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Big Category -->
      <div class="filtersDropdown">
        <mat-form-field appearance="fill" class="datepickerwidth">
          <mat-label>Select Business Group</mat-label>
          <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
             formControlName="bigcategories"
            multiple (selectionChange)="clearData()">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="bigCategoryAllSelected" [ngModelOptions]="{standalone: true}"
                (change)="toggleBigCategoryAllSelection()">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Generate Report Buttons -->
      <div class="filtersDropdown">
        <button class="btn-qm" color="primary" (click)="generateReport()">
          Generate Report
        </button>
      </div>
      <!-- Export Excel -->
      <!-- <div class="filtersDropdown">
        <button class="btn-qm" color="primary" (click)="exportExcel()">
          <i class="export-icon"></i>  Export Excel
        </button>
      </div> -->
      <div class="alert alert-danger failMsg" *ngIf="showValidationMessage">
        {{ValidationMsg}}
      </div>
    </div>
    <div class="example-container" *ngIf="showgrid">
        <div *ngIf="nofiltereddata" class="records" >{{noRecords}}</div>
        <div class="comparative-container mat-elevation-z8" *ngIf="!nofiltereddata">
          
        <table mat-table id="tbl-cayoy" [dataSource]="comparativeAnalysisDataSource" *ngIf="!nofiltereddata">
            <!-- Level0 Column -->
            <ng-container matColumnDef="level0">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Level0 </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
                <span>{{element.level0}}</span>
            </td>
            <td class="leftDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mLevel0">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">Level0</th>
            </ng-container>
            
            <!-- Loss Tress Column -->
            <ng-container matColumnDef="defectmodeaggregation">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Loss Tree </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element">
                <span>{{element.defectmodeaggregation}}</span>
            </td>
            <td class="leftDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mDefectmodeaggregation">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">Loss Tree</th>
            </ng-container>
            <!-- Cluster Column -->
            <ng-container matColumnDef="subregion">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> BUSub Region </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.subregion}} </td>
            <td class="leftDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mCluster">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">BU Sub Rgion</th>
            </ng-container>
            <!-- Site Column -->
            <ng-container matColumnDef="sites">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Site </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.sites}} </td>
            <td class="leftDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mSites">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">Site</th>
            </ng-container>
            <!-- Big Category -->
            <ng-container matColumnDef="Business Group">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> Business Group </th>
            <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.businessgroup}} </td>
            <td class="leftDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mBigcategory">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">Business Group</th>
            </ng-container>
            <!-- 4Ms -->
            <ng-container matColumnDef="fourms">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"> 4Ms </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.fourms}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="mFourms">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.rowspan]="3">4Ms</th>
            </ng-container>
            <!-- Occurances H1 Year2 -->
  
            <!-- Occurances H2 Year2 -->
           
            <!-- Change Occurances -->
          
            
            <!-- PDCASTATUS H1 -->
            
            <!-- PDCASTATUS H2 -->
            
            <!-- DefectPriorityIndex H1 Year2 -->
           
            <!-- DefectPriorityIndex H2 Year2 -->
           
            <!-- Change DPI Year2 -->
           
            <!-- occurances Y1 -->
            <ng-container matColumnDef="occurancesY1">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesY1}} </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesY1}} </td>
              <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- occurances Y2 -->
            <ng-container matColumnDef="occurancesY2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesY2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesY2}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Defectpriorityindex Y1 -->
            <ng-container matColumnDef="defectpriorityindexY1">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexY1}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexY1 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- DefectPriorityIndex Y2 -->
            <ng-container matColumnDef="defectpriorityindexY2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexY2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexY2 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Change DPI YoY -->
            <ng-container matColumnDef="changeindpiYoY">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef > Change % </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.changeindpiYoY}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- occurances H1 Y1 -->
            <ng-container matColumnDef="occurancesH1Y1">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesH1Y1}} </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesH1Y1}} </td>
              <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- occurances H1 Y2 -->
            <ng-container matColumnDef="occurancesH1Y2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesH1Y2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesH1Y2}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Defectpriorityindex H1 Y1 -->
            <ng-container matColumnDef="defectpriorityindexH1Y1">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexH1Y1}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexH1Y1 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Defectpriorityindex H1 Y2 -->
            <ng-container matColumnDef="defectpriorityindexH1Y2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexH1Y2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexH1Y2 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Change DPI H1 of (Y1 - Y2) -->
            <ng-container matColumnDef="changeindpiH1">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef > Change % </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.changeindpiH1}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- occurances H2 Y1 -->
            <ng-container matColumnDef="occurancesH2Y1">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesH2Y1}} </th>
              <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesH2Y1}} </td>
              <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- occurances H2 Y2 -->
            <ng-container matColumnDef="occurancesH2Y2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerOccurancesH2Y2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.occurancesH2Y2}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Defectpriorityindex H2 Y1 -->
            <ng-container matColumnDef="defectpriorityindexH2Y1">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexH2Y1}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexH2Y1 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Defectpriorityindex H2 Y2 -->
            <ng-container matColumnDef="defectpriorityindexH2Y2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef> {{headerDefectpriorityindexH2Y2}} </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindexH2Y2 | number}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Change DPI H2 of (Y1 - Y2) -->
            <ng-container matColumnDef="changeindpiH2">
            <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef > Change % </th>
            <td class="centerDataCell" mat-cell *matCellDef="let element"> {{element.changeindpiH2}} </td>
            <td class="centerDataCell" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <!-- Middle Grouping Occurances Columns -->
            <ng-container matColumnDef="Header-occurance-group">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Occurances </th>
              </ng-container>
            <!-- Middle Grouping DPI Columns-->
            <ng-container matColumnDef="Header-dpi-group">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="3"> Defect Priority Index </th>
            </ng-container>
            <!-- Top Grouping H1 & H2 Year2  -->
            <ng-container matColumnDef="Header-common-group">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="6"> </th>
            </ng-container>
       
            <ng-container matColumnDef="Header-group-yoy">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="5"> Yearly Comparison Data </th>
            </ng-container>
            <ng-container matColumnDef="Header-group-h1y1y2">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="5"> H1 (Year1 & Year2) Comparison Data </th>
            </ng-container>
            <ng-container matColumnDef="Header-group-h2y1y2">
              <th class="centerHeaderCell" mat-header-cell *matHeaderCellDef [attr.colspan]="6"> H2 (Year1 & Year2) Comparison Data </th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['Header-common-group','Header-group-yoy','Header-group-h1y1y2','Header-group-h2y1y2']; sticky: true;"></tr>
            <tr mat-header-row *matHeaderRowDef="['mLevel0','mDefectmodeaggregation','mCluster','mSites','mBigcategory','mFourms', 'Header-occurance-group', 'Header-dpi-group','Header-occurance-group','Header-dpi-group','Header-occurance-group','Header-dpi-group']; sticky: true;"></tr>
            <tr mat-header-row *matHeaderRowDef="comparativeAnalysisCol; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row; columns: comparativeAnalysisCol;"></tr>
            <tr mat-footer-row *matFooterRowDef="comparativeAnalysisCol"></tr>
        </table>
        </div>
    </div>
</div>